import React from "react";
import {
  AMT_ATTACH_ID,
  PLAN_CARDS_ID,
  REVAMP_COMPONENT_MAPPER,
} from "./componentMapper";
import { ITripOption } from "./components/AmtAttach/types";

export interface ComponentCard {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

interface ComponentRendererProps {
  components?: ComponentCard[];
  onLoginRequest?: () => void;
  onAmtToggle?: (enabled: boolean) => void;
  amtEnabled?: boolean;
  onCompareClick?: () => void;
  pageTracked?: boolean;
  tripOptions?: ITripOption[];
  selectedTripOption?: string;
  onTripOptionChange?: (optionId: string) => void;
  onInfoIconClick?: (optionId: string) => void;
  isLoading?: boolean;
}

const ComponentRenderer: React.FC<ComponentRendererProps> = ({
  components,
  onLoginRequest,
  onAmtToggle,
  amtEnabled,
  onCompareClick,
  pageTracked,
  tripOptions,
  selectedTripOption,
  onTripOptionChange,
  onInfoIconClick,
  isLoading,
}) => {
  if (!components) {
    return null;
  }

  return (
    <>
      {components.map((card, index) => {
        if (!card?.id) return null;
        const CardComponent = REVAMP_COMPONENT_MAPPER[card.id];
        if (!CardComponent) return null;

        const key = `${card.id}-${index}`;
        const isAmtAttach = card.id === AMT_ATTACH_ID;
        const isPlanCards = card.id === PLAN_CARDS_ID;

        if (card.data && typeof card.data === "object") {
          return (
            <CardComponent
              key={key}
              {...card.data}
              onLoginRequest={onLoginRequest}
              pageTracked={pageTracked}
              {...(isAmtAttach && {
                onToggle: onAmtToggle,
                enabled: amtEnabled,
              })}
              {...(isPlanCards && {
                onCompareClick,
                tripOptions,
                selectedTripOption,
                onTripOptionChange,
                onInfoIconClick,
                isLoading,
              })}
            />
          );
        }
        return (
          <CardComponent
            key={key}
            data={card.data}
            onLoginRequest={onLoginRequest}
            pageTracked={pageTracked}
            {...(isAmtAttach && {
              onToggle: onAmtToggle,
              enabled: amtEnabled,
            })}
            {...(isPlanCards && {
              onCompareClick,
              tripOptions,
              selectedTripOption,
              onTripOptionChange,
              onInfoIconClick,
              isLoading,
            })}
          />
        );
      })}
    </>
  );
};

export default ComponentRenderer;
